/**
 * Bus minimal : signale qu'un composant (typiquement `AppShell`, § lien « Organisation ») doit
 * recharger `/me/organizations`.
 *
 * Même schéma que `onUnauthenticated` (`lib/api.js`) : un événement qui n'est pas une erreur
 * HTTP n'a pas sa place dans ce fichier-là, mais la recette — un `Set` d'abonnés, pas un
 * contexte React — reste la bonne pour un événement déclenché par un composant qui n'est
 * l'ancêtre d'aucun autre (ici : le dialogue de suppression d'organisation, ouvert depuis
 * `OrganizationPage`, doit notifier `AppShell`, qui vit au-dessus de lui dans l'arbre).
 */

const handlers = new Set();

/** Branché par les composants qui affichent la liste des organisations de l'utilisateur. */
export function onOrganizationsChanged(handler) {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

/** À appeler après toute création, suppression ou perte d'accès à une organisation. */
export function notifyOrganizationsChanged() {
  handlers.forEach((handler) => handler());
}
